import { createSelector } from '@ngrx/store';
import { selectMenusState } from '../../ngrx/menus.selectors';

const selectState = createSelector(
  selectMenusState,
  (state) => state?.menu_edit ?? null,
);

export const selectCurrentSpellcheckItem = createSelector(
  selectState,
  (state) => state?.current_spellcheck_item ?? null,
);

export const selectCurrentMenu = createSelector(selectState, (state) =>
  state ? state.current_menu : null,
);

export const selectCurrentMenuOnboardingTemplateDetail = createSelector(
  selectState,
  (state) => state.current_menu?.onboarding_template_detail,
);

export const selectStyleModified = createSelector(
  selectState,
  (state) => state?.current_menu?.style_modified,
);

export const selectStyleBackgroundImages = createSelector(
  selectState,
  (state) => state?.background_images.filter((img) => img.type === 1) ?? [],
);

export const selectWriteBackgroundImages = createSelector(
  selectState,
  (state) => state?.background_images.filter((img) => img.type === 2) ?? [],
);

export const selectIsAiAnalysisLoading = createSelector(
  selectState,
  (state) => state?.ai_analysis_loading,
);
